import { render, staticRenderFns } from "./alarmEventsList.vue?vue&type=template&id=f5d785d6"
import script from "./alarmEventsList.vue?vue&type=script&lang=js"
export * from "./alarmEventsList.vue?vue&type=script&lang=js"
import style0 from "./alarmEventsList.vue?vue&type=style&index=0&id=f5d785d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports